import { Component, OnInit, inject } from '@angular/core'
import { BreakpointService } from '../../services'
import { animate, query, state, style, transition, trigger } from '@angular/animations'
import { RouterOutlet } from '@angular/router'

@Component({
    selector: 'lib-master-detail',
    templateUrl: './master-detail.component.html',
    styleUrls: ['./master-detail.component.scss'],
    animations: [
        trigger('expandListingTrigger', [
            state('collapse', style({
                width: '320px'
            })),
            state('expand', style({
                width: '100%'
            })),
            transition('* => expand', [
                animate('510ms ease-out')
            ]),
            transition('* => collapse', [
                animate('510ms ease-out')
            ])
        ])
    ],
    imports: [RouterOutlet]
})
export class MasterDetailComponent implements OnInit {
    breakpoints = inject(BreakpointService)


    private isOutletActive = false

    ngOnInit() {

    }

    onOutletActivated($event: any) {
        // Primarily here for debugging...
        this.isOutletActive = true
    }

    onOutletDeactivated($event: any) {
        // Primarily here for debugging...
        this.isOutletActive = false
    }

}
